import React from 'react';
import Tooltip from '../components/Tooltip/index.js'
import { useIsDesktopReal } from '../hooks/useMediaQuery.js';

const CustomTooltip = ({ children, label = undefined }) => {
    const isDesktop = useIsDesktopReal();

    return isDesktop && label
        ?
        <Tooltip label={label}>
            {children}
        </Tooltip>
        :
        <div>
            {children}
        </div>
}
export default CustomTooltip;
